import { t } from '../../../common/i18n/index.js';
import { PopoverContent } from './CommercialProductContent.js';

export const ReissunettiOnePopoverContent = () => (
  <PopoverContent>
    <div>
      <strong>Elisa Reissunetti 1-1,5 </strong>
      {t.X0II(
        'GB is activated automatically in the target countries and offers a fast data transfer connection using a mobile device or laptop computer at an affordable price in countries outside the EU/EEA. The service has no monthly charge. Instead, pricing is activated based on usage at €21.90 per 14 days.'
      )}
    </div>
  </PopoverContent>
);
